import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios, { AxiosRequestConfig } from 'axios';
import BootstrapTable from 'react-bootstrap-table-next';
import { Redirect } from 'react-router-dom';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import OrderInquiryBasicInfo from './order_inquiry_basic_info';
const upcomingColumns = [
    {
        dataField: 'Date',
        text: 'Date',
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    },
    {
        dataField: 'Technician',
        text: 'Technician',
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    }];
const columns = [
    {
        dataField: 'visitDate',
        text: 'Date',
        sort: true,
        formatter: dateFormat,
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    },
    {
        dataField: 'technician',
        text: 'Technician',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    },
    {
        dataField: 'serviceNotes',
        text: 'Service Notes',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { textAlign: 'center' };
        }
    }];


function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

class OrderSiteVisits extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        this.state = {
            user: userExists ? props.location.state.user : {},
            input: props.location.state.data,
            visits: [],
            selected: [],
            appointments: [],
            relatedFiles: [],
            headerLabel: props.location.state.data.OrderType == 'Service' ? 'Service Notes' : 'Contract Service Notes',
            loading: false
        };

        this.downloadSelected = this.downloadSelected.bind(this);
        this.showButton = this.showButton.bind(this);
        /*this.createSelectItems = this.createSelectItems.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);*/
    }

    componentDidMount() {
        axios.get(`${Constants.apiURL}/api/Order/GetSiteVisits`, {
            params: {
                username: this.state.user.username,
                orderKey: this.state.input.OrderKey
            }
        }).then(response => {
            if (response.data) {

                this.setState(() => ({
                    visits: response.data
                }), () => {
                    if (this.state.input.OrderType == 'Service') {
                        axios.get(`${Constants.apiURL}/api/Order/GetExtraOrderDetails`, {
                            params: {
                                orderType: this.state.input.OrderType,
                                orderKey: this.state.input.OrderKey
                            }
                        }).then(response => {
                            if (response.data) {
                                let appointments = [];
                                let relatedFiles = [];
                                if (response.data.appointments) {
                                    appointments = JSON.parse(response.data.appointments);
                                }
                                if (response.data.relatedFiles) {
                                    relatedFiles = JSON.parse(response.data.relatedFiles);
                                }

                                this.setState({
                                    appointments: appointments,
                                    relatedFiles: relatedFiles
                                });
                            }
                        }).catch((response) => {
                            // ? Show to user that request is failed
                            this.setState({ errors: [response] })
                            this.setState({ loading: false });
                        });
                    }
                });
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleFormChange(event) {
        console.log(event);
        let input = this.state.input;
        input[event.target.name] = event.target.value;

        this.setState({
            input
        });
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    }


    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadSelected}>
                Download Selected
            </Button>
        }
    }

    downloadSelected(event) {

        if (this.state.selected.length == 0) { return; }
        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Order/DownloadSiteVisits`, {
            user: this.state.user.username,
            visits: this.state.selected
        }, {
            'headers': {
                'content-type': 'application/json'
            },
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            this.setState({ loading: false });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: 'application/zip' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleSelect = (row, isSelect) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = [...this.state.selected, row];
        } else {
            allow = false;
            CurrentSelected = this.state.selected.filter(x => x !== row);
        }
        this.state.selected = CurrentSelected;
    }

    handleSelectAll = (isSelect, rows) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = rows;
        } else {
            CurrentSelected = [];
        }
        this.state.selected = CurrentSelected;
    }

    render() {
        const relatedFilesColumns = [
            {
                text: '',
                dataField: 'x',
                formatter: (cell, row) => {
                    return <Button style={{ backgroundColor: '#1F419B', width: '100%' }} onClick={(event) => {

                        axios.get(`${Constants.apiURL}/api/Guest/DownloadFile`, {
                            params: {
                                user: this.state.user.username,
                                id: row.DocLinkID
                            },
                            responseType: "blob"
                        }).then(response => {
                            this.setState({ loading: false });

                            let blob = new Blob([response.data], { type: "application/pdf" }),
                                downloadUrl = window.URL.createObjectURL(blob),
                                filename = "",
                                disposition = response.headers["content-disposition"];

                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                                    matches = filenameRegex.exec(disposition);

                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, "");
                                }
                            }
                            else {
                                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                                return;
                            }

                            let a = document.createElement("a");
                            if (typeof a.download === "undefined") {
                                window.location.href = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        }).catch((response) => {
                            // ? Show to user that request is failed
                            this.setState({ errors: [response] })
                            this.setState({ loading: false });
                            console.log('request failed', response)
                        });
                    }}>Download</Button>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Date Uploaded',
                dataField: 'CreatedDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Type',
                dataField: 'DocumentType',
                headerStyle: (colum, colIndex) => {
                    return { width: '200px', textAlign: 'center' };
                }
            },
            {
                text: 'Equipment Serial Number(s)',
                dataField: 'MachineSerials',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center' };
                },
                formatter: (cell, row) => {
                    let machines = cell.split(',');
                    return machines.map((item) => {
                        return <div>
                            <span>{item}</span><br />
                        </div>;
                    });
                }
            },
            {
                text: 'Report Findings?',
                dataField: 'ReviewRequired',
                headerStyle: (colum, colIndex) => {
                    return { width: '160px', textAlign: 'center', wordBreak: 'break-all' };
                },
                style: (cell, row, rowIndex, colIndex) => {
                    return { wordBreak: 'break-all' };
                },
                formatter: (cell, row) => {
                    return cell == null || cell == false ? "No" : "Yes";
                }
            }];
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll,
        };
        return (
            <div class="site_visit">
                <SiteMenu user={this.state.user} currentPage='orderSiteVisits' />
                <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">{this.state.headerLabel}</Form.Label>
                <OrderInquiryBasicInfo style={{ margin: 5 }} data={this.state.input} />
                <div style={{ width: '500px' }} hidden={this.state.input.SubType != 'ServiceCall'}>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Upcoming Appointments</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="Id"
                        wrapperClasses="table-responsive"
                        data={this.state.appointments}
                        columns={upcomingColumns}
                        onTableChange={this.onTableChange}
                        noDataIndication={() =>
                            <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                No upcoming appointments for this order.
                            </Form.Label>}
                        striped
                        hover
                    />
                </div>
                <div style={{ width:'840px' }}>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Related Files</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="DocumentID"
                        wrapperClasses="table-responsive"
                        data={this.state.relatedFiles}
                        columns={relatedFilesColumns}
                        onTableChange={this.onTableChange}
                        noDataIndication={() =>
                            <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                No related files for this order.
                            </Form.Label>}
                        striped
                        hover
                    />
                </div>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Completed Site Visits</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="id"
                        selectRow={selectRow}
                        wrapperClasses="table-responsive"
                        data={this.state.visits}
                        columns={columns}
                        onTableChange={this.onTableChange}
                        noDataIndication={() =>
                            <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                Service notes have not yet been completed. If you have questions on this order, please submit an order inquiry&nbsp;
                                <Link to={{
                                    pathname: '/order_inquiry',
                                    state: {
                                        user: this.state.user,
                                        data: this.state.input
                                    }
                                }}>here</Link>
                            </Form.Label>}
                        striped
                        hover
                    />
                    {this.showButton()}
            </div>
        );
    }
}

export default OrderSiteVisits;